import Version, { Step } from 'embed_v2/types/version'
import { createContext } from 'preact'
import ItemApi from '../ItemApi'
import type { Notification } from './Widget'
import type Session from 'embed_v2/types/session'
import type ThankyouData from 'embed_v2/types/thankyou_data'
import type Viewer from 'embed_v2/types/viewer'

type WidgetContextValues = {
  currentStep: Step
  version: Version
  sessions: Session[]
  session: Session | undefined
  viewer: Viewer
  prevStep: () => void
  nextStep: () => void
  setSessions: (val: Session[]) => void
  onSessionChange: (val: Session) => void
  redirectToJoinUrl: () => void
  isSessionValid: (s: { scheduled_at: string; expires_at?: string }) => boolean
  setViewerField: (field: any, value: any) => void
  notification: Notification
  thankYouData?: ThankyouData
  isSubmitting: boolean
  api: ItemApi
  newPrevStep: Step | undefined
  newNextStep: Step | undefined
  canNextStep: boolean
  updateViewer: () => Promise<void> | undefined
  remainTimeWorker: Worker | undefined
  unsafeTagRegistrant: (tag: string) => void
  cloudflareTurnstileRef: (node: HTMLElement | null) => void
  cloudflareTurnstileInteractive: boolean
}

const WidgetContext = createContext<WidgetContextValues>({} as WidgetContextValues)
export default WidgetContext
